// src/features/clinical/pages/PrescriptionPage.jsx
import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import PatientSearch from '../components/patient/PatientSearch';
import PrescriptionCreation from '../components/prescription/PrescriptionCreation';
import clinicalApi from '../services/clinicalApi';

const PrescriptionPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedVisit, setSelectedVisit] = useState(null);
  const [doctor] = useState({ id: '', name: '' });

  const visitId = searchParams.get('visitId');
  const patientId = searchParams.get('patientId');

  useEffect(() => {
    if (visitId) {
      loadVisitDetails();
    } else if (patientId) {
      loadPatientDetails();
    }
  }, [visitId, patientId]);

  const loadVisitDetails = async () => {
    try {
      const response = await clinicalApi.getVisit(visitId);
      setSelectedVisit(response.data);
      setSelectedPatient({ id: response.data.patientId, name: response.data.patientName });
    } catch (error) {
      console.error('Failed to load visit:', error);
    }
  };

  const loadPatientDetails = async () => {
    try {
      const response = await clinicalApi.getPatient(patientId);
      setSelectedPatient({ id: response.data.id, name: response.data.name });
    } catch (error) {
      console.error('Failed to load patient:', error);
    }
  };

  const handlePrescriptionComplete = () => {
    navigate('/clinical/prescriptions');
  };

  return (
    <div className="max-w-7xl mx-auto px-4">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Create Prescription</h1>
      
      {!selectedPatient ? (
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-lg font-medium text-gray-900 mb-4">Select Patient</h2>
          <PatientSearch onSelectPatient={setSelectedPatient} />
        </div>
      ) : (
        <PrescriptionCreation
          visitId={selectedVisit?.id}
          patientId={selectedPatient.id}
          patientName={selectedPatient.full_name}
          doctorId={doctor.id}
          onComplete={handlePrescriptionComplete}
        />
      )}
    </div>
  );
};

export default PrescriptionPage;